import React from 'react'
import * as Sentry from "@sentry/react";

export default function PageNotFound() {
  Sentry.captureMessage("Page not found");
  return (
    <div>Page Not Found</div>
  )
}
